import { EventActionDefinition } from "components/events/eventActions";
import { TableRestrictionsImpl } from "components/table/tableRestrictions";
import { RowKey } from "components/table/rowKey";
import { TableStatus } from "components/table/tableStatus";
import { ColumnDefinition, TableColumn } from "components/table/columns/ColumnDefinitions";
import "datatables.net";


export class CheckColumn implements DataTables.ColumnDefsSettings, TableColumn {

    public width = "1";
    public orderable = false;
    public className = "c-datatable__action-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    public definition: CheckColumnDefinition;
    private rowKey: RowKey;
    private tablestatus: TableStatus;
    private restrictions: TableRestrictionsImpl;

    constructor(
        column: number,
        definition: CheckColumnDefinition,
        rowKey: RowKey,
        tablestatus: TableStatus,
        restrictions: TableRestrictionsImpl) {
        this.definition = definition;
        this.targets = column;
        this.property = definition.property;
        this.name = this.property;
        this.rowKey = rowKey;
        this.tablestatus = tablestatus;
        this.restrictions = restrictions;
    }

    public render = (data: boolean | CheckboxDefinition, type: string, row: any, meta: any) => {
        if (type === "display") {
            let html = [];
            //TODO EVO1
            html.push("<input type='checkbox' class='editor-active js-table-selector '");
            if (isCheckBoxDefinition(data)) {
                let checkbox = data as CheckboxDefinition;
                // La fnc isChecked entra en juego cuando se esta paginanado, y esta marcado el checkbox de cabecera de seleccionar todos
                const isChecked = this.isChecked(row);
                const isReadOnly = this.isReadOnly();
                if ((!isReadOnly) && (isChecked)) {
                    html.push("checked");
                    checkbox.checked = true;
                } else if ((!isReadOnly) && (!isChecked)) {
                    checkbox.checked = false;
                }
                if (checkbox.disabled || isReadOnly) {
                    html.push("disabled");
                }
            } else {
                if (data && !this.isReadOnly()) {
                    if (this.isChecked(row)) {
                        html.push("checked");
                    }
                } else {
                    html.push("disabled");
                }
            }
            html.push(">");
            return html.join("");
        }
        return data;
    }

    private isReadOnly(): boolean {
        return this.restrictions?.isColumnReadOnly(this.property);
    }

    private isChecked(row: any[]): boolean {
        if (this.rowKey == null) {
            return false;
        }
        return (this.tablestatus.isChecked(this.property, this.rowKey.key(row)));
    }
}

export interface CheckColumnDefinition extends ColumnDefinition {
    rowStyle?: string;
    canSelectByCriteria?: boolean;
    eventActions?: EventActionDefinition[];
}

export function isCheckColumnDefinition(arg: any): arg is CheckColumnDefinition {
    return arg.type === "CheckColumn";
}

export function isCheckBoxDefinition(arg: any): boolean {
    return (arg != null && (arg.hasOwnProperty("checked") || arg.hasOwnProperty("disabled")));
}

export interface CheckboxDefinition {
    checked: boolean;
    disabled: boolean;
}
